import $ from 'jquery'
import {UserManagementConstants} from 'constants'
import {EXCEPTIONS} from '../../../panels/user/editPanel/util'

export const getSavedActiveTabNumOrDefault = () => {
    let tabVal = $.cookie("actiTime-userlist-tabs")
    if (tabVal) {
        tabVal = Number(tabVal)
    } else {
        tabVal = UserManagementConstants.ACCOUNT_SETTINGS_TAB_NUM
    }
    return tabVal
}

export const saveActiveTabNum = (tabNum) => {
    $.cookie("actiTime-userlist-tabs", tabNum, {expires: 4000})
}

export const haveMoreLicenses = (licenseCounters) => {
    const remainingCount = licenseCounters.remainingCount
    return isLicenseUnlimited(licenseCounters) || remainingCount > 0
}

export const isLicenseUnlimited = (licenseCounters) => {
    return licenseCounters.remainingCount === UserManagementConstants.LICENSE_UNLIM
}

export const isLicenseViolated = (licenseCounters) => {
    return licenseCounters.licenseViolated
}

export const handleCommonExceptions = rpcError => {
    rpcError.handleOnException(EXCEPTIONS.NoSuchUserException)
    rpcError.handleOnException(EXCEPTIONS.NoRightsToManageAccountSettings)
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/common/utils.js